

/**
 * Populate retailers exit buttons
 * @param {*} retailers 
 */
export const renderRetailers = retailers => {
    // Target DOM container
    const dom_container = document.querySelector('.retailers');

    // Single retailer
    // <a href="URL" target="_blank" class='retailer __ID__ ' id='exit-__ID__'>
    let link;

    // retailer logo inside the <a> tag
    // <img src="./img/retailers/__ID__.jpg" alt="__NAME__">
    let logo

    // loop through data array. need error check at some point
    retailers.forEach(data => {
        // Create DOM
        link = document.createElement('a');
        // Set the link target window
        link.target = '_blank';
        // Set "retailer" class
        link.classList.add('retailer');
        // Set spcific retailer class. Not currently being used.
        link.classList.add(data.id);
        // Set ID
        link.id = `exit-${data.id}`;
        // Set link URL
        link.href = data.url;
        // Set title. Can be seen on mouse over
        link.title = data.name;

        // Create DOM
        logo = document.createElement('img');
        // Set path to the image
        logo.src = `./img/retailers/${data.id}.jpg`;
        // Set alternative text for load error.
        logo.alt = data.name;

        // Add logo to link tag
        link.appendChild(logo);

        // Add link tag to the container
        dom_container.appendChild(link);
    })

}



/**
 * Step 1, 2, 3 exit URLs
 * @param {Object} C 
 */
export const setStepExits = C => {
    // console.log('setStepExits')

    // DOM queries for step 1 - 3
    const Q = ['#exit-step1', '#exit-step2', '#exit-step3'];

    // Loop through queries
    Q.forEach(query => {
        // get IDs in JSON config
        const id = query.replace('#exit-', '');
        const dom = document.querySelector(query);
        // Apply URL
        if (C.exits[id] && dom && dom.href) {
            dom.href = C.exits[id];
        }
    })
}


